/// <amd-module name="VSSUI/Components/HubHeader/HubTextTile" />
import * as React from "react";
import { BaseComponent } from "OfficeFabric/Utilities";
import { css } from "VSSUI/Util";
import { DynamicText } from "VSSUI/Dynamic";
import { IHubTextTileProps } from "../../Components/HubHeader/HubTextTile.Props";

/**
 * Hub tile comprised of text, and an optional icon
 */
/** @deprecated */
export class HubTextTile extends BaseComponent<IHubTextTileProps> {
    public render(): JSX.Element {
        const { text, secondaryText } = this.props;
        const className = css("vss-HubTextTile vss-HubTile");

        return (
            <div className={className}>
                <DynamicText
                    text={text}
                    className={css("vss-HubTextTile--primaryText", !this.props.secondaryText && "vss-HubTextTile--primaryTextOnly")}
                />
                <DynamicText text={secondaryText} className="vss-HubTextTile--secondaryText" />
            </div>
        );
    }
}
